import React from 'react';
import { Link } from 'react-router-dom';
import { useFeatureFlag } from '../services/featureFlags';

const Reports = () => {
  const { hasFeatureFlag, loading: loadingFeatureFlag } = useFeatureFlag();

  return (
    <div className="reports-page">
      <div className="report-links">
        <Link className="link" to="/reports/summary">Exercise Summary Report</Link>
        <Link className="link" to="/reports/results">Exercise Results Report</Link>
        {hasFeatureFlag('fireFlow') && <Link className="link" to="/reports/fireFlowResults">Fire Flow Results Report</Link>}
        {hasFeatureFlag('hydrantFlush') && <Link className="link" to="/reports/hydrantFlushResults">Hydrant Flush Results Report</Link>}
      </div>
    </div>
  );
};

export default Reports;